"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ComboBoxTags = function (_a) {
    var selectedValues = _a.selectedValues, tagFocusedIndex = _a.tagFocusedIndex, onRemoveClick = _a.onRemoveClick, displayValue = _a.displayValue;
    var generateOptionId = function () {
        return (Math.random().toString(36) + Date.now().toString(36)).substr(2, 10);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, selectedValues.map(function (option, index) {
        return (react_1.default.createElement("div", { key: "tagClose_" + generateOptionId(), role: "none", onClick: function (e) {
                e.stopPropagation();
            }, className: "c-chip " + (index === tagFocusedIndex ? 'focus' : ''), "data-tag-index": index, "data-tag-focus": index === tagFocusedIndex ? 'true' : null },
            react_1.default.createElement("span", { className: "c-chip__label" }, displayValue(option)),
            react_1.default.createElement("button", { type: "button", className: "c-chip__close", "aria-label": "Remove", tabIndex: -1, onClick: function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    onRemoveClick(option);
                    // removeTag(option);
                } },
                react_1.default.createElement("span", { "aria-hidden": "true" }, "\u00D7"))));
    })));
};
exports.default = ComboBoxTags;
